import React from 'react'
import Button from './Button'

/**
 * Reusable pagination footer component
 * Provides consistent pagination UI across the application
 * Supports custom button text, styling, and disabled states
 */
const PaginationFooter = ({
  currentPage = 1,
  totalPages = 1,
  onPageChange,
  previousText = 'Previous',
  nextText = 'Next',
  className = '',
  showPageInfo = true,
  pageInfoText = null,
  disabled = false,
  size = 'small',
  variant = 'outline'
}) => {
  // Custom page info text or default format
  const getPageInfo = () => {
    if (pageInfoText) return pageInfoText
    return `Page ${currentPage} of ${totalPages}`
  }

  // Handle page change with validation
  const handlePageChange = (newPage) => {
    if (disabled || newPage < 1 || newPage > totalPages) return
    onPageChange?.(newPage)
  }

  // Check if buttons should be disabled
  const isPreviousDisabled = disabled || currentPage <= 1
  const isNextDisabled = disabled || currentPage >= totalPages

  return (
    <div className={`flex items-center justify-between p-3 border-t border-gray-200 bg-white ${className}`}>
      <Button
        variant={variant}
        size={size}
        disabled={isPreviousDisabled}
        onClick={() => handlePageChange(currentPage - 1)}
      >
        {previousText}
      </Button>
      
      {showPageInfo && (
        <span className="text-sm text-gray-600">
          {getPageInfo()}
        </span>
      )}
      
      <Button
        variant={variant}
        size={size}
        disabled={isNextDisabled}
        onClick={() => handlePageChange(currentPage + 1)}
      >
        {nextText}
      </Button>
    </div>
  )
}

export default PaginationFooter
